import styled from 'styled-components';

export default styled.div`
  width: 30px;
  height: 30px;

  border: 2px solid ${({ theme }) => theme.colors.gray.shades['90']};
  border-top: 2px solid ${({ theme }) => theme.colors.primary.color};
  border-radius: 100%;
  animation: spin 1s infinite linear;

  margin-left: auto;
  margin-right: auto;

  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  z-index: 2100;
  width: 30px;
  height: 30px;
`;
